import React, { useCallback, useEffect, useState, useMemo } from "react";
import { SecondaryGrayButton } from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import AuthService from "@/services/AuthService";

interface Deployment {
  id: number;
  deploymentId: string;
  displayName: string;
  teamId: number;
  siteId: number;
}

export default function LivePreviewButton() {
  const api = useApi();
  const [deployment, setDeployment] = useState<Deployment | null>(null);

  const fetchDeployment = useCallback(async () => {
    const resp = await api.messaging.get(`Deployment`);
    const deployments = await resp.json();
    // Use first deployment as the active one
    if (deployments && deployments.length > 0) {
      setDeployment(deployments[0]);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetchDeployment();
  }, [fetchDeployment]);

  const linkUrl = useMemo(() => {
    if (!deployment) {
      return "";
    }

    return `${import.meta.env
      .VITE_MESSAGING_CLIENT_URL!}/example_embed.html?siteId=${AuthService.profile.siteId.toString()}&deploymentId=${
      deployment.deploymentId
    }`;
  }, [deployment]);

  return (
    <SecondaryGrayButton
      label="Live Preview"
      onClick={() => window.open(linkUrl, "_blank")}
      disabled={!deployment}
      className="font-medium !text-slate-600"
    />
  );
}